module.exports = __webpack_public_path__ + "img/1.b3fe2ba6.jpg";